import { Input } from 'entities/Input'
import { useEffect, useState } from 'react'
import { useBranchStore } from 'shared/store/branchesSlice'

export const ZipCode = () => {
  const { branchList, branchId, updateBranch } = useBranchStore()
  const [zip, setZip] = useState<string>('')

  useEffect(() => {
    if (branchId && branchList?.length) {
      setZip(branchList?.find(branch => branch.Intern === branchId)?.ZipCode || '')
    }
  }, [branchList?.length, branchId])

  const updateZip = () => {
    if (branchList?.find(branch => branch.Intern === branchId)?.ZipCode !== zip) {
      updateBranch({ ZipCode: zip })
    }
  }

  return <Input label='Zip Code' onChange={setZip} onBlur={updateZip} value={zip} />
}
